{
  "comment": "M2 spec §7.2. requestRange and autodockRange are measured from the station's hull: the distance to the station centre less its bounding radius (StationRuntime.radius; scale build §3.3, SC-5a1a), so on a km-scale station they still start outside the hull. The corridor starts at the bay mouth; impact.proximity is from the bounds; autopilot.stationMargin is added to the radius. The autopilot's detour and entry legs fly at up to autopilot.detourSpeed beyond autopilot.detourNear of the entry point and at approachSpeed within it (SC-5a1b). The autopilot lets a hull cross the bay mouth once its cross-section at its current attitude (ShipDef.hullHalfExtents about ShipDef.hullCentre, the asset bounds box, whose centre it flies onto the bay axis and the pad) keeps autopilot.hullMargin to each mouth wall, and fails a hull that cannot keep it even lined up or is longer than the bay (D-999). hullMargin is also the asset pipeline's bayFit margin: tools/asset-pipeline/schemas.ts reads it from here, so the two agree (D-TBD).",
  "requestRange": 5000,
  "clearanceSeconds": 180,
  "autodockRange": 2000,
  "corridor": { "length": 1500, "ringSpacing": 100, "radiusMult": 1.2 },
  "speedLimits": { "corridor": 100, "bay": 10 },
  "dock": { "maxSpeed": 5, "maxAlignDeg": 15, "holdSeconds": 2 },
  "impact": { "freeSpeed": 5, "damagePerMps": 4, "proximity": 200 },
  "launch": { "speed": 20 },
  "autopilot": {
    "entryDistance": 400,
    "approachSpeed": 90,
    "detourSpeed": 200,
    "detourNear": 1000,
    "corridorSpeed": 60,
    "baySpeed": 6,
    "finalSpeed": 1.5,
    "lateralGain": 0.5,
    "turnGain": 2.5,
    "rollGain": 1.5,
    "stationMargin": 150,
    "arriveRadius": 25,
    "hullMargin": 3
  }
}
